import sendToServer from './send-to-server';

const JournalApplication = {
  init() {
    if (!($('.journal.edit-application').length > 0)) return;
    this.setUpResizeables();

    $('.edit-application input, .edit-application select').change(this.handleAttributeChanged.bind(this));

    this.showAppropriateChecklist();
  },

  setUpResizeables() {
    $('h1 input').keyup(this.resizeInput).each(this.resizeInput);
  },

  resizeInput(event_or_index, element) {
    const input = element ? $(element) : $(event_or_index.target.closest('input'));
    input.attr('size', input.val().length + 1);
  },

  handleAttributeChanged(event) {
    const input = $(event.target);
    if (input.prop('type') === 'checkbox') return this.updateTasks();
    if (input.prop('name') === 'status') this.showAppropriateChecklist();
    if (input.val() === input.data('original')) return;
    const id = $('#application-identifier').data('id');
    sendToServer('/api/v2/journal/applications/' + id,
                 { [input.prop('name')]: input.val() },
                 null,
                 'PATCH');
  },

  updateTasks() {
    const completedTasks = $('.checklist-item input:checked').map((_, element) => {
      return $(element).data('task');
    });

    const uniques = Array.from(new Set(completedTasks.toArray()));
    const id = $('#application-identifier').data('id');
    sendToServer('/api/v2/journal/applications/' + id,
                 { tasks: uniques },
                 null,
                 'PATCH');
  },

  showAppropriateChecklist() {
    const status = $('select[name="status"]').val();
    $('.details-section').hide();
    $('.' + status + '-details').show();
  }
};

$(document).ready(()=> {
  JournalApplication.init();
});
